/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody,
  AssignmentViewModel,
  BulkImportFromExternalProviderDtoArrayBody,
  BulkImportPreviewRowDto,
  ExternalReceiptModel,
  FindReceiptsRequestBody,
  GenericPageResultDtoOfCircleKTransactionDto,
  GenericPageResultDtoOfReceiptLineItemDTO,
  GetMyUnmappedReceiptLineItemsRequest,
  MessagesMarkAsReadByUserCaseeventidBody,
  ProductExpenseTypeMappingDto,
  ReceiptAssignReceiptToAssignmentParams,
  ReceiptBulkImportFromExternalProviderParams,
  ReceiptChangeValidStatusOfExternalReceiptLineItemParams,
  ReceiptFindApplicableAssignmentsForReceiptParams,
  ReceiptFindMyApplicableAssignmentsForReceiptParams,
  ReceiptFindReceiptsParams,
  ReceiptGetExpenseTypesMapping200Five,
  ReceiptGetExpenseTypesMapping200Four,
  ReceiptGetExpenseTypesMapping200One,
  ReceiptGetExpenseTypesMapping200Three,
  ReceiptGetExpenseTypesMapping200Two,
  ReceiptLineItemDTO,
  ReceiptPreviewBulkImportFromExternalProviderParams,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useReceiptFindReceiptLineItemsHook = () => {
  const receiptFindReceiptLineItems =
    useCustomInstance<GenericPageResultDtoOfReceiptLineItemDTO>();

  return useCallback(
    (findReceiptsRequestBody: FindReceiptsRequestBody) => {
      return receiptFindReceiptLineItems({
        url: `/api/Receipt/FindReceiptLineItems`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: findReceiptsRequestBody,
      });
    },
    [receiptFindReceiptLineItems]
  );
};

export const useReceiptFindReceiptLineItemsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useReceiptFindReceiptLineItemsHook>>>,
    TError,
    { data: FindReceiptsRequestBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useReceiptFindReceiptLineItemsHook>>>,
  TError,
  { data: FindReceiptsRequestBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const receiptFindReceiptLineItems = useReceiptFindReceiptLineItemsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useReceiptFindReceiptLineItemsHook>>>,
    { data: FindReceiptsRequestBody }
  > = (props) => {
    const { data } = props ?? {};

    return receiptFindReceiptLineItems(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptFindReceiptLineItemsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useReceiptFindReceiptLineItemsHook>>>
>;
export type ReceiptFindReceiptLineItemsMutationBody = FindReceiptsRequestBody;
export type ReceiptFindReceiptLineItemsMutationError = unknown;

export const useReceiptFindReceiptLineItems = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useReceiptFindReceiptLineItemsHook>>>,
    TError,
    { data: FindReceiptsRequestBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useReceiptFindReceiptLineItemsHook>>>,
  TError,
  { data: FindReceiptsRequestBody },
  TContext
> => {
  const mutationOptions =
    useReceiptFindReceiptLineItemsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useReceiptFindCircleKReceiptLineItemsHook = () => {
  const receiptFindCircleKReceiptLineItems =
    useCustomInstance<GenericPageResultDtoOfCircleKTransactionDto>();

  return useCallback(
    (findReceiptsRequestBody: FindReceiptsRequestBody) => {
      return receiptFindCircleKReceiptLineItems({
        url: `/api/Receipt/FindCircleKReceiptLineItems`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: findReceiptsRequestBody,
      });
    },
    [receiptFindCircleKReceiptLineItems]
  );
};

export const useReceiptFindCircleKReceiptLineItemsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptFindCircleKReceiptLineItemsHook>>
    >,
    TError,
    { data: FindReceiptsRequestBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useReceiptFindCircleKReceiptLineItemsHook>>
  >,
  TError,
  { data: FindReceiptsRequestBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const receiptFindCircleKReceiptLineItems =
    useReceiptFindCircleKReceiptLineItemsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptFindCircleKReceiptLineItemsHook>>
    >,
    { data: FindReceiptsRequestBody }
  > = (props) => {
    const { data } = props ?? {};

    return receiptFindCircleKReceiptLineItems(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptFindCircleKReceiptLineItemsMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useReceiptFindCircleKReceiptLineItemsHook>>
  >
>;
export type ReceiptFindCircleKReceiptLineItemsMutationBody =
  FindReceiptsRequestBody;
export type ReceiptFindCircleKReceiptLineItemsMutationError = unknown;

export const useReceiptFindCircleKReceiptLineItems = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptFindCircleKReceiptLineItemsHook>>
    >,
    TError,
    { data: FindReceiptsRequestBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useReceiptFindCircleKReceiptLineItemsHook>>
  >,
  TError,
  { data: FindReceiptsRequestBody },
  TContext
> => {
  const mutationOptions =
    useReceiptFindCircleKReceiptLineItemsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useReceiptFindReceiptsHook = () => {
  const receiptFindReceipts = useCustomInstance<ExternalReceiptModel[]>();

  return useCallback(
    (params?: ReceiptFindReceiptsParams) => {
      return receiptFindReceipts({
        url: `/api/Receipt/FindReceipts`,
        method: 'POST',
        params,
      });
    },
    [receiptFindReceipts]
  );
};

export const useReceiptFindReceiptsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useReceiptFindReceiptsHook>>>,
    TError,
    { params?: ReceiptFindReceiptsParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useReceiptFindReceiptsHook>>>,
  TError,
  { params?: ReceiptFindReceiptsParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const receiptFindReceipts = useReceiptFindReceiptsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useReceiptFindReceiptsHook>>>,
    { params?: ReceiptFindReceiptsParams }
  > = (props) => {
    const { params } = props ?? {};

    return receiptFindReceipts(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptFindReceiptsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useReceiptFindReceiptsHook>>>
>;

export type ReceiptFindReceiptsMutationError = unknown;

export const useReceiptFindReceipts = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useReceiptFindReceiptsHook>>>,
    TError,
    { params?: ReceiptFindReceiptsParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useReceiptFindReceiptsHook>>>,
  TError,
  { params?: ReceiptFindReceiptsParams },
  TContext
> => {
  const mutationOptions = useReceiptFindReceiptsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useReceiptGetReceiptByLineItemIdHook = () => {
  const receiptGetReceiptByLineItemId = useCustomInstance<ReceiptLineItemDTO>();

  return useCallback(
    (
      messagesMarkAsReadByUserCaseeventidBody: MessagesMarkAsReadByUserCaseeventidBody
    ) => {
      return receiptGetReceiptByLineItemId({
        url: `/api/Receipt/GetReceiptByLineItemId`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: messagesMarkAsReadByUserCaseeventidBody,
      });
    },
    [receiptGetReceiptByLineItemId]
  );
};

export const useReceiptGetReceiptByLineItemIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptGetReceiptByLineItemIdHook>>
    >,
    TError,
    { data: MessagesMarkAsReadByUserCaseeventidBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useReceiptGetReceiptByLineItemIdHook>>>,
  TError,
  { data: MessagesMarkAsReadByUserCaseeventidBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const receiptGetReceiptByLineItemId = useReceiptGetReceiptByLineItemIdHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptGetReceiptByLineItemIdHook>>
    >,
    { data: MessagesMarkAsReadByUserCaseeventidBody }
  > = (props) => {
    const { data } = props ?? {};

    return receiptGetReceiptByLineItemId(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptGetReceiptByLineItemIdMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useReceiptGetReceiptByLineItemIdHook>>>
>;
export type ReceiptGetReceiptByLineItemIdMutationBody =
  MessagesMarkAsReadByUserCaseeventidBody;
export type ReceiptGetReceiptByLineItemIdMutationError = unknown;

export const useReceiptGetReceiptByLineItemId = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptGetReceiptByLineItemIdHook>>
    >,
    TError,
    { data: MessagesMarkAsReadByUserCaseeventidBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useReceiptGetReceiptByLineItemIdHook>>>,
  TError,
  { data: MessagesMarkAsReadByUserCaseeventidBody },
  TContext
> => {
  const mutationOptions =
    useReceiptGetReceiptByLineItemIdMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useReceiptGetExpenseTypesMappingHook = () => {
  const receiptGetExpenseTypesMapping = useCustomInstance<
    | ReceiptGetExpenseTypesMapping200One
    | ReceiptGetExpenseTypesMapping200Two
    | ReceiptGetExpenseTypesMapping200Three
    | ReceiptGetExpenseTypesMapping200Four
    | ReceiptGetExpenseTypesMapping200Five
  >();

  return useCallback(
    (signal?: AbortSignal) => {
      return receiptGetExpenseTypesMapping({
        url: `/api/Receipt/GetExpenseTypesMapping`,
        method: 'GET',
        signal,
      });
    },
    [receiptGetExpenseTypesMapping]
  );
};

export const getReceiptGetExpenseTypesMappingQueryKey = () => {
  return [`/api/Receipt/GetExpenseTypesMapping`] as const;
};

export const useReceiptGetExpenseTypesMappingQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useReceiptGetExpenseTypesMappingHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptGetExpenseTypesMappingHook>>
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReceiptGetExpenseTypesMappingQueryKey();

  const receiptGetExpenseTypesMapping = useReceiptGetExpenseTypesMappingHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useReceiptGetExpenseTypesMappingHook>>>
  > = ({ signal }) => receiptGetExpenseTypesMapping(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptGetExpenseTypesMappingHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ReceiptGetExpenseTypesMappingQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useReceiptGetExpenseTypesMappingHook>>>
>;
export type ReceiptGetExpenseTypesMappingQueryError = unknown;

export const useReceiptGetExpenseTypesMapping = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useReceiptGetExpenseTypesMappingHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptGetExpenseTypesMappingHook>>
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useReceiptGetExpenseTypesMappingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useReceiptFindApplicableAssignmentsForReceiptHook = () => {
  const receiptFindApplicableAssignmentsForReceipt =
    useCustomInstance<AssignmentViewModel[]>();

  return useCallback(
    (params?: ReceiptFindApplicableAssignmentsForReceiptParams) => {
      return receiptFindApplicableAssignmentsForReceipt({
        url: `/api/Receipt/FindApplicableAssignmentsForReceipt`,
        method: 'POST',
        params,
      });
    },
    [receiptFindApplicableAssignmentsForReceipt]
  );
};

export const useReceiptFindApplicableAssignmentsForReceiptMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptFindApplicableAssignmentsForReceiptHook>
      >
    >,
    TError,
    { params?: ReceiptFindApplicableAssignmentsForReceiptParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useReceiptFindApplicableAssignmentsForReceiptHook>
    >
  >,
  TError,
  { params?: ReceiptFindApplicableAssignmentsForReceiptParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const receiptFindApplicableAssignmentsForReceipt =
    useReceiptFindApplicableAssignmentsForReceiptHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptFindApplicableAssignmentsForReceiptHook>
      >
    >,
    { params?: ReceiptFindApplicableAssignmentsForReceiptParams }
  > = (props) => {
    const { params } = props ?? {};

    return receiptFindApplicableAssignmentsForReceipt(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptFindApplicableAssignmentsForReceiptMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptFindApplicableAssignmentsForReceiptHook>
      >
    >
  >;

export type ReceiptFindApplicableAssignmentsForReceiptMutationError = unknown;

export const useReceiptFindApplicableAssignmentsForReceipt = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptFindApplicableAssignmentsForReceiptHook>
      >
    >,
    TError,
    { params?: ReceiptFindApplicableAssignmentsForReceiptParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useReceiptFindApplicableAssignmentsForReceiptHook>
    >
  >,
  TError,
  { params?: ReceiptFindApplicableAssignmentsForReceiptParams },
  TContext
> => {
  const mutationOptions =
    useReceiptFindApplicableAssignmentsForReceiptMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useReceiptFindMyApplicableAssignmentsForReceiptHook = () => {
  const receiptFindMyApplicableAssignmentsForReceipt =
    useCustomInstance<AssignmentViewModel[]>();

  return useCallback(
    (params?: ReceiptFindMyApplicableAssignmentsForReceiptParams) => {
      return receiptFindMyApplicableAssignmentsForReceipt({
        url: `/api/Receipt/FindMyApplicableAssignmentsForReceipt`,
        method: 'POST',
        params,
      });
    },
    [receiptFindMyApplicableAssignmentsForReceipt]
  );
};

export const useReceiptFindMyApplicableAssignmentsForReceiptMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptFindMyApplicableAssignmentsForReceiptHook>
      >
    >,
    TError,
    { params?: ReceiptFindMyApplicableAssignmentsForReceiptParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useReceiptFindMyApplicableAssignmentsForReceiptHook>
    >
  >,
  TError,
  { params?: ReceiptFindMyApplicableAssignmentsForReceiptParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const receiptFindMyApplicableAssignmentsForReceipt =
    useReceiptFindMyApplicableAssignmentsForReceiptHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptFindMyApplicableAssignmentsForReceiptHook>
      >
    >,
    { params?: ReceiptFindMyApplicableAssignmentsForReceiptParams }
  > = (props) => {
    const { params } = props ?? {};

    return receiptFindMyApplicableAssignmentsForReceipt(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptFindMyApplicableAssignmentsForReceiptMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptFindMyApplicableAssignmentsForReceiptHook>
      >
    >
  >;

export type ReceiptFindMyApplicableAssignmentsForReceiptMutationError = unknown;

export const useReceiptFindMyApplicableAssignmentsForReceipt = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptFindMyApplicableAssignmentsForReceiptHook>
      >
    >,
    TError,
    { params?: ReceiptFindMyApplicableAssignmentsForReceiptParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useReceiptFindMyApplicableAssignmentsForReceiptHook>
    >
  >,
  TError,
  { params?: ReceiptFindMyApplicableAssignmentsForReceiptParams },
  TContext
> => {
  const mutationOptions =
    useReceiptFindMyApplicableAssignmentsForReceiptMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useReceiptAssignReceiptToAssignmentHook = () => {
  const receiptAssignReceiptToAssignment = useCustomInstance<void>();

  return useCallback(
    (params?: ReceiptAssignReceiptToAssignmentParams) => {
      return receiptAssignReceiptToAssignment({
        url: `/api/Receipt/AssignReceiptToAssignment`,
        method: 'POST',
        params,
      });
    },
    [receiptAssignReceiptToAssignment]
  );
};

export const useReceiptAssignReceiptToAssignmentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptAssignReceiptToAssignmentHook>>
    >,
    TError,
    { params?: ReceiptAssignReceiptToAssignmentParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useReceiptAssignReceiptToAssignmentHook>>
  >,
  TError,
  { params?: ReceiptAssignReceiptToAssignmentParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const receiptAssignReceiptToAssignment =
    useReceiptAssignReceiptToAssignmentHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptAssignReceiptToAssignmentHook>>
    >,
    { params?: ReceiptAssignReceiptToAssignmentParams }
  > = (props) => {
    const { params } = props ?? {};

    return receiptAssignReceiptToAssignment(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptAssignReceiptToAssignmentMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useReceiptAssignReceiptToAssignmentHook>>
  >
>;

export type ReceiptAssignReceiptToAssignmentMutationError = unknown;

export const useReceiptAssignReceiptToAssignment = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptAssignReceiptToAssignmentHook>>
    >,
    TError,
    { params?: ReceiptAssignReceiptToAssignmentParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useReceiptAssignReceiptToAssignmentHook>>
  >,
  TError,
  { params?: ReceiptAssignReceiptToAssignmentParams },
  TContext
> => {
  const mutationOptions =
    useReceiptAssignReceiptToAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useReceiptUpdateProductExpenseTypeMappingHook = () => {
  const receiptUpdateProductExpenseTypeMapping = useCustomInstance<void>();

  return useCallback(
    (productExpenseTypeMappingDto: ProductExpenseTypeMappingDto) => {
      return receiptUpdateProductExpenseTypeMapping({
        url: `/api/Receipt/UpdateProductExpenseTypeMapping`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: productExpenseTypeMappingDto,
      });
    },
    [receiptUpdateProductExpenseTypeMapping]
  );
};

export const useReceiptUpdateProductExpenseTypeMappingMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptUpdateProductExpenseTypeMappingHook>
      >
    >,
    TError,
    { data: ProductExpenseTypeMappingDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useReceiptUpdateProductExpenseTypeMappingHook>>
  >,
  TError,
  { data: ProductExpenseTypeMappingDto },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const receiptUpdateProductExpenseTypeMapping =
    useReceiptUpdateProductExpenseTypeMappingHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptUpdateProductExpenseTypeMappingHook>
      >
    >,
    { data: ProductExpenseTypeMappingDto }
  > = (props) => {
    const { data } = props ?? {};

    return receiptUpdateProductExpenseTypeMapping(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptUpdateProductExpenseTypeMappingMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useReceiptUpdateProductExpenseTypeMappingHook>>
  >
>;
export type ReceiptUpdateProductExpenseTypeMappingMutationBody =
  ProductExpenseTypeMappingDto;
export type ReceiptUpdateProductExpenseTypeMappingMutationError = unknown;

export const useReceiptUpdateProductExpenseTypeMapping = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptUpdateProductExpenseTypeMappingHook>
      >
    >,
    TError,
    { data: ProductExpenseTypeMappingDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useReceiptUpdateProductExpenseTypeMappingHook>>
  >,
  TError,
  { data: ProductExpenseTypeMappingDto },
  TContext
> => {
  const mutationOptions =
    useReceiptUpdateProductExpenseTypeMappingMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useReceiptGetProductExpenseTypeMappingsHook = () => {
  const receiptGetProductExpenseTypeMappings =
    useCustomInstance<ProductExpenseTypeMappingDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return receiptGetProductExpenseTypeMappings({
        url: `/api/Receipt/GetProductExpenseTypeMappings`,
        method: 'GET',
        signal,
      });
    },
    [receiptGetProductExpenseTypeMappings]
  );
};

export const getReceiptGetProductExpenseTypeMappingsQueryKey = () => {
  return [`/api/Receipt/GetProductExpenseTypeMappings`] as const;
};

export const useReceiptGetProductExpenseTypeMappingsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useReceiptGetProductExpenseTypeMappingsHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptGetProductExpenseTypeMappingsHook>>
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReceiptGetProductExpenseTypeMappingsQueryKey();

  const receiptGetProductExpenseTypeMappings =
    useReceiptGetProductExpenseTypeMappingsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptGetProductExpenseTypeMappingsHook>>
    >
  > = ({ signal }) => receiptGetProductExpenseTypeMappings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptGetProductExpenseTypeMappingsHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ReceiptGetProductExpenseTypeMappingsQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useReceiptGetProductExpenseTypeMappingsHook>>
  >
>;
export type ReceiptGetProductExpenseTypeMappingsQueryError = unknown;

export const useReceiptGetProductExpenseTypeMappings = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useReceiptGetProductExpenseTypeMappingsHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptGetProductExpenseTypeMappingsHook>>
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useReceiptGetProductExpenseTypeMappingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useReceiptBulkImportFromExternalProviderHook = () => {
  const receiptBulkImportFromExternalProvider = useCustomInstance<Blob>();

  return useCallback(
    (
      bulkImportFromExternalProviderDtoArrayBody: BulkImportFromExternalProviderDtoArrayBody,
      params?: ReceiptBulkImportFromExternalProviderParams
    ) => {
      return receiptBulkImportFromExternalProvider({
        url: `/api/Receipt/BulkImportFromExternalProvider`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bulkImportFromExternalProviderDtoArrayBody,
        params,
        responseType: 'blob',
      });
    },
    [receiptBulkImportFromExternalProvider]
  );
};

export const useReceiptBulkImportFromExternalProviderMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptBulkImportFromExternalProviderHook>
      >
    >,
    TError,
    {
      data: BulkImportFromExternalProviderDtoArrayBody;
      params?: ReceiptBulkImportFromExternalProviderParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useReceiptBulkImportFromExternalProviderHook>>
  >,
  TError,
  {
    data: BulkImportFromExternalProviderDtoArrayBody;
    params?: ReceiptBulkImportFromExternalProviderParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const receiptBulkImportFromExternalProvider =
    useReceiptBulkImportFromExternalProviderHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptBulkImportFromExternalProviderHook>
      >
    >,
    {
      data: BulkImportFromExternalProviderDtoArrayBody;
      params?: ReceiptBulkImportFromExternalProviderParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return receiptBulkImportFromExternalProvider(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptBulkImportFromExternalProviderMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useReceiptBulkImportFromExternalProviderHook>>
  >
>;
export type ReceiptBulkImportFromExternalProviderMutationBody =
  BulkImportFromExternalProviderDtoArrayBody;
export type ReceiptBulkImportFromExternalProviderMutationError = unknown;

export const useReceiptBulkImportFromExternalProvider = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptBulkImportFromExternalProviderHook>
      >
    >,
    TError,
    {
      data: BulkImportFromExternalProviderDtoArrayBody;
      params?: ReceiptBulkImportFromExternalProviderParams;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useReceiptBulkImportFromExternalProviderHook>>
  >,
  TError,
  {
    data: BulkImportFromExternalProviderDtoArrayBody;
    params?: ReceiptBulkImportFromExternalProviderParams;
  },
  TContext
> => {
  const mutationOptions =
    useReceiptBulkImportFromExternalProviderMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useReceiptPreviewBulkImportFromExternalProviderHook = () => {
  const receiptPreviewBulkImportFromExternalProvider =
    useCustomInstance<BulkImportPreviewRowDto[]>();

  return useCallback(
    (
      bulkImportFromExternalProviderDtoArrayBody: BulkImportFromExternalProviderDtoArrayBody,
      params?: ReceiptPreviewBulkImportFromExternalProviderParams
    ) => {
      return receiptPreviewBulkImportFromExternalProvider({
        url: `/api/Receipt/PreviewBulkImportFromExternalProvider`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bulkImportFromExternalProviderDtoArrayBody,
        params,
      });
    },
    [receiptPreviewBulkImportFromExternalProvider]
  );
};

export const useReceiptPreviewBulkImportFromExternalProviderMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptPreviewBulkImportFromExternalProviderHook>
      >
    >,
    TError,
    {
      data: BulkImportFromExternalProviderDtoArrayBody;
      params?: ReceiptPreviewBulkImportFromExternalProviderParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useReceiptPreviewBulkImportFromExternalProviderHook>
    >
  >,
  TError,
  {
    data: BulkImportFromExternalProviderDtoArrayBody;
    params?: ReceiptPreviewBulkImportFromExternalProviderParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const receiptPreviewBulkImportFromExternalProvider =
    useReceiptPreviewBulkImportFromExternalProviderHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptPreviewBulkImportFromExternalProviderHook>
      >
    >,
    {
      data: BulkImportFromExternalProviderDtoArrayBody;
      params?: ReceiptPreviewBulkImportFromExternalProviderParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return receiptPreviewBulkImportFromExternalProvider(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptPreviewBulkImportFromExternalProviderMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptPreviewBulkImportFromExternalProviderHook>
      >
    >
  >;
export type ReceiptPreviewBulkImportFromExternalProviderMutationBody =
  BulkImportFromExternalProviderDtoArrayBody;
export type ReceiptPreviewBulkImportFromExternalProviderMutationError = unknown;

export const useReceiptPreviewBulkImportFromExternalProvider = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptPreviewBulkImportFromExternalProviderHook>
      >
    >,
    TError,
    {
      data: BulkImportFromExternalProviderDtoArrayBody;
      params?: ReceiptPreviewBulkImportFromExternalProviderParams;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useReceiptPreviewBulkImportFromExternalProviderHook>
    >
  >,
  TError,
  {
    data: BulkImportFromExternalProviderDtoArrayBody;
    params?: ReceiptPreviewBulkImportFromExternalProviderParams;
  },
  TContext
> => {
  const mutationOptions =
    useReceiptPreviewBulkImportFromExternalProviderMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useReceiptAttemptBulkConnectExternalLineItemsToExpensesHook =
  () => {
    const receiptAttemptBulkConnectExternalLineItemsToExpenses =
      useCustomInstance<Blob>();

    return useCallback(
      (
        assignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody
      ) => {
        return receiptAttemptBulkConnectExternalLineItemsToExpenses({
          url: `/api/Receipt/AttemptBulkConnectExternalLineItemsToExpenses`,
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          data: assignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody,
          responseType: 'blob',
        });
      },
      [receiptAttemptBulkConnectExternalLineItemsToExpenses]
    );
  };

export const useReceiptAttemptBulkConnectExternalLineItemsToExpensesMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useReceiptAttemptBulkConnectExternalLineItemsToExpensesHook
          >
        >
      >,
      TError,
      {
        data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useReceiptAttemptBulkConnectExternalLineItemsToExpensesHook
        >
      >
    >,
    TError,
    {
      data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody;
    },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const receiptAttemptBulkConnectExternalLineItemsToExpenses =
      useReceiptAttemptBulkConnectExternalLineItemsToExpensesHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useReceiptAttemptBulkConnectExternalLineItemsToExpensesHook
          >
        >
      >,
      {
        data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody;
      }
    > = (props) => {
      const { data } = props ?? {};

      return receiptAttemptBulkConnectExternalLineItemsToExpenses(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReceiptAttemptBulkConnectExternalLineItemsToExpensesMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useReceiptAttemptBulkConnectExternalLineItemsToExpensesHook
        >
      >
    >
  >;
export type ReceiptAttemptBulkConnectExternalLineItemsToExpensesMutationBody =
  AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody;
export type ReceiptAttemptBulkConnectExternalLineItemsToExpensesMutationError =
  unknown;

export const useReceiptAttemptBulkConnectExternalLineItemsToExpenses = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useReceiptAttemptBulkConnectExternalLineItemsToExpensesHook
        >
      >
    >,
    TError,
    {
      data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<
        typeof useReceiptAttemptBulkConnectExternalLineItemsToExpensesHook
      >
    >
  >,
  TError,
  { data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody },
  TContext
> => {
  const mutationOptions =
    useReceiptAttemptBulkConnectExternalLineItemsToExpensesMutationOptions(
      options
    );

  return useMutation(mutationOptions);
};
export const useReceiptGetMyUnmappedReceiptLineItemsHook = () => {
  const receiptGetMyUnmappedReceiptLineItems =
    useCustomInstance<ReceiptLineItemDTO[]>();

  return useCallback(
    (
      getMyUnmappedReceiptLineItemsRequest: GetMyUnmappedReceiptLineItemsRequest
    ) => {
      return receiptGetMyUnmappedReceiptLineItems({
        url: `/api/Receipt/GetMyUnmappedReceiptLineItems`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: getMyUnmappedReceiptLineItemsRequest,
      });
    },
    [receiptGetMyUnmappedReceiptLineItems]
  );
};

export const useReceiptGetMyUnmappedReceiptLineItemsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptGetMyUnmappedReceiptLineItemsHook>>
    >,
    TError,
    { data: GetMyUnmappedReceiptLineItemsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useReceiptGetMyUnmappedReceiptLineItemsHook>>
  >,
  TError,
  { data: GetMyUnmappedReceiptLineItemsRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const receiptGetMyUnmappedReceiptLineItems =
    useReceiptGetMyUnmappedReceiptLineItemsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptGetMyUnmappedReceiptLineItemsHook>>
    >,
    { data: GetMyUnmappedReceiptLineItemsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return receiptGetMyUnmappedReceiptLineItems(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptGetMyUnmappedReceiptLineItemsMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useReceiptGetMyUnmappedReceiptLineItemsHook>>
  >
>;
export type ReceiptGetMyUnmappedReceiptLineItemsMutationBody =
  GetMyUnmappedReceiptLineItemsRequest;
export type ReceiptGetMyUnmappedReceiptLineItemsMutationError = unknown;

export const useReceiptGetMyUnmappedReceiptLineItems = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useReceiptGetMyUnmappedReceiptLineItemsHook>>
    >,
    TError,
    { data: GetMyUnmappedReceiptLineItemsRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useReceiptGetMyUnmappedReceiptLineItemsHook>>
  >,
  TError,
  { data: GetMyUnmappedReceiptLineItemsRequest },
  TContext
> => {
  const mutationOptions =
    useReceiptGetMyUnmappedReceiptLineItemsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useReceiptGetMyUnmappedReceiptLineItemsCountHook = () => {
  const receiptGetMyUnmappedReceiptLineItemsCount = useCustomInstance<number>();

  return useCallback(() => {
    return receiptGetMyUnmappedReceiptLineItemsCount({
      url: `/api/Receipt/GetMyUnmappedReceiptLineItemsCount`,
      method: 'POST',
    });
  }, [receiptGetMyUnmappedReceiptLineItemsCount]);
};

export const useReceiptGetMyUnmappedReceiptLineItemsCountMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptGetMyUnmappedReceiptLineItemsCountHook>
      >
    >,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useReceiptGetMyUnmappedReceiptLineItemsCountHook>
    >
  >,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const receiptGetMyUnmappedReceiptLineItemsCount =
    useReceiptGetMyUnmappedReceiptLineItemsCountHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptGetMyUnmappedReceiptLineItemsCountHook>
      >
    >,
    void
  > = () => {
    return receiptGetMyUnmappedReceiptLineItemsCount();
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptGetMyUnmappedReceiptLineItemsCountMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptGetMyUnmappedReceiptLineItemsCountHook>
      >
    >
  >;

export type ReceiptGetMyUnmappedReceiptLineItemsCountMutationError = unknown;

export const useReceiptGetMyUnmappedReceiptLineItemsCount = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useReceiptGetMyUnmappedReceiptLineItemsCountHook>
      >
    >,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useReceiptGetMyUnmappedReceiptLineItemsCountHook>
    >
  >,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    useReceiptGetMyUnmappedReceiptLineItemsCountMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useReceiptChangeValidStatusOfExternalReceiptLineItemHook = () => {
  const receiptChangeValidStatusOfExternalReceiptLineItem =
    useCustomInstance<void>();

  return useCallback(
    (params?: ReceiptChangeValidStatusOfExternalReceiptLineItemParams) => {
      return receiptChangeValidStatusOfExternalReceiptLineItem({
        url: `/api/Receipt/ChangeValidStatusOfExternalReceiptLineItem`,
        method: 'POST',
        params,
      });
    },
    [receiptChangeValidStatusOfExternalReceiptLineItem]
  );
};

export const useReceiptChangeValidStatusOfExternalReceiptLineItemMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useReceiptChangeValidStatusOfExternalReceiptLineItemHook
          >
        >
      >,
      TError,
      { params?: ReceiptChangeValidStatusOfExternalReceiptLineItemParams },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useReceiptChangeValidStatusOfExternalReceiptLineItemHook
        >
      >
    >,
    TError,
    { params?: ReceiptChangeValidStatusOfExternalReceiptLineItemParams },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const receiptChangeValidStatusOfExternalReceiptLineItem =
      useReceiptChangeValidStatusOfExternalReceiptLineItemHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useReceiptChangeValidStatusOfExternalReceiptLineItemHook
          >
        >
      >,
      { params?: ReceiptChangeValidStatusOfExternalReceiptLineItemParams }
    > = (props) => {
      const { params } = props ?? {};

      return receiptChangeValidStatusOfExternalReceiptLineItem(params);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReceiptChangeValidStatusOfExternalReceiptLineItemMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useReceiptChangeValidStatusOfExternalReceiptLineItemHook
        >
      >
    >
  >;

export type ReceiptChangeValidStatusOfExternalReceiptLineItemMutationError =
  unknown;

export const useReceiptChangeValidStatusOfExternalReceiptLineItem = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useReceiptChangeValidStatusOfExternalReceiptLineItemHook
        >
      >
    >,
    TError,
    { params?: ReceiptChangeValidStatusOfExternalReceiptLineItemParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<
        typeof useReceiptChangeValidStatusOfExternalReceiptLineItemHook
      >
    >
  >,
  TError,
  { params?: ReceiptChangeValidStatusOfExternalReceiptLineItemParams },
  TContext
> => {
  const mutationOptions =
    useReceiptChangeValidStatusOfExternalReceiptLineItemMutationOptions(
      options
    );

  return useMutation(mutationOptions);
};
export const useReceiptGetLastReceiptDateHook = () => {
  const receiptGetLastReceiptDate = useCustomInstance<Date>();

  return useCallback(
    (signal?: AbortSignal) => {
      return receiptGetLastReceiptDate({
        url: `/api/Receipt/GetLastReceiptDate`,
        method: 'GET',
        signal,
      });
    },
    [receiptGetLastReceiptDate]
  );
};

export const getReceiptGetLastReceiptDateQueryKey = () => {
  return [`/api/Receipt/GetLastReceiptDate`] as const;
};

export const useReceiptGetLastReceiptDateQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useReceiptGetLastReceiptDateHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useReceiptGetLastReceiptDateHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReceiptGetLastReceiptDateQueryKey();

  const receiptGetLastReceiptDate = useReceiptGetLastReceiptDateHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useReceiptGetLastReceiptDateHook>>>
  > = ({ signal }) => receiptGetLastReceiptDate(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useReceiptGetLastReceiptDateHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ReceiptGetLastReceiptDateQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useReceiptGetLastReceiptDateHook>>>
>;
export type ReceiptGetLastReceiptDateQueryError = unknown;

export const useReceiptGetLastReceiptDate = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useReceiptGetLastReceiptDateHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useReceiptGetLastReceiptDateHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useReceiptGetLastReceiptDateQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
